import type { Media } from "../Media.js";
import type {
	Product,
	ProductAttributeGroupOfValue,
	ProductForCustomer,
	ProductOfVariant,
	ProductOfVariantForCustomer,
} from "../Product.js";

export function getProductPrimaryMedia(
	product: ProductOfVariant | ProductOfVariantForCustomer | Product | ProductForCustomer,
	attributes: Pick<ProductAttributeGroupOfValue, "value" | "id">[],
): Media | undefined {
	// this logic only applies to the fact that we currently only support one attribute group (color)
	const [firstAttribute] = attributes;
	if (firstAttribute) {
		const attribute = product.attributeGroups
			.find(({ id }) => id === firstAttribute.id)
			?.values.find(({ id }) => id === firstAttribute.value.id);
		if (attribute?.photo) {
			return attribute.photo;
		}
	}
	const firstGalleryPhoto = product.gallery.find(({ photo }) => photo !== undefined)?.photo;
	if ("variant" in product) {
		return product.variant.photo ?? firstGalleryPhoto;
	}
	return product.variants.find(({ photo }) => photo !== undefined)?.photo ?? firstGalleryPhoto;
}
